import { useState } from 'react';
import { Button, Drawer, Switch, Descriptions, Input } from 'antd';
import { iBuildVideoOptions } from 'shared/video';
import { StoryTimelineController_buildVideo } from './timeButtons';

export const TimelineBuildVideoComponent = (props: { qStory: any; storyId: number }) => {
  const [open, setOpen] = useState(false);
  const [allFiles, setAllFiles] = useState(false);
  const [randomOrder, setRandomOrder] = useState(false);
  const [properTimeStamps, setProperTimeStamps] = useState(false);
  const [addRandomFrames, setAddRandomFrames] = useState(0);
  // const [maxAudioDuration, setMaxAudioDuration] = useState<'auto'>('auto');

  const opt: iBuildVideoOptions = {
    allFiles,
    // maxAudioDuration,
    randomOrder,
    addRandomFramesToEnd: addRandomFrames,
    properTimeStamps,
  };

  return (
    <>
      <Button type="default" size="small" onClick={() => setOpen(true)}>
        Построить видео
      </Button>
      <Drawer title="Построение видео" open={open} onClose={() => setOpen(false)} width={800}>
        <Descriptions title="Video settings" column={1} bordered>
          <Descriptions.Item label="Использовать все аудио-файлы">
            <Switch checked={allFiles} onChange={setAllFiles} />
          </Descriptions.Item>
          <Descriptions.Item label="Случайный порядок кадров">
            <Switch checked={randomOrder} onChange={setRandomOrder} />
          </Descriptions.Item>
          <Descriptions.Item label="Добавить случайных кадров в конец видео">
            <Input
              type="number"
              placeholder="Количество случайных кадров"
              value={addRandomFrames}
              min={0}
              onChange={e => {
                setAddRandomFrames(Number(e.target.value));
              }}
            />
          </Descriptions.Item>
          {/* <Descriptions.Item label="Макс. длительность аудио">
            <Select value={maxAudioDuration} style={{ width: 120 }} onChange={setMaxAudioDuration}>
              <Select.Option value="auto">auto</Select.Option>
              <Select.Option value={30}>30</Select.Option>
              <Select.Option value={60}>60</Select.Option>
              <Select.Option value={120}>120</Select.Option>
            </Select>
          </Descriptions.Item> */}

          <Descriptions.Item
            label={
              <>
                Использовать точные метки времени
                <br /> (Если кадра нет то будет картинка статичная или чёрный экран)
                <br /> Not ready yet
              </>
            }
          >
            <Switch checked={properTimeStamps} onChange={setProperTimeStamps} disabled />
          </Descriptions.Item>
        </Descriptions>
        <br />
        <StoryTimelineController_buildVideo qStory={props.qStory} storyId={Number(props.storyId)} opt={opt} />
      </Drawer>
    </>
  );
};
